import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    FormControlLabel,
    Switch,
} from '@mui/material';
import { useAddEventType, useEditEventType } from '../../hooks/useEventType';

const EventTypeForm = ({ open, onClose, formData, onInputChange, editData = null }) => {
    const addEventType = useAddEventType();
    const editEventType = useEditEventType();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editData) {
                await editEventType.mutateAsync({
                    id: editData.id,
                    data: formData
                });
            } else {
                await addEventType.mutateAsync(formData);
            }
            onClose();
        } catch (error) {
            console.error('Error submitting event type:', error);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle className="bg-blueColor text-white py-4">
                <i className={`fas ${editData ? 'fa-edit' : 'fa-plus'} text-xl mx-2`}></i>
                <span className="text-xl font-semibold">
                    {editData ? 'Edit Event Type' : 'Add New Event Type'}
                </span>
            </DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent className="mt-4">
                    <div className="grid grid-cols-1 gap-4 p-4">
                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Name
                            </label>
                            <input
                                name="name"
                                value={formData.name}
                                onChange={onInputChange}
                                type="text"
                                required
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 text-sm font-bold mb-2">
                                Description
                            </label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={onInputChange}
                                className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                                rows="4"
                            />
                        </div>

                        <div className="grid grid-cols-1 gap-4 mt-4">
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formData.allow_app_sign}
                                        onChange={(e) => onInputChange({
                                            target: {
                                                name: 'allow_app_sign',
                                                value: e.target.checked
                                            }
                                        })}
                                    />
                                }
                                label="Allow App Sign"
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formData.can_add_attendees}
                                        onChange={(e) => onInputChange({
                                            target: {
                                                name: 'can_add_attendees',
                                                value: e.target.checked
                                            }
                                        })}
                                    />
                                }
                                label="Can Add Attendees"
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formData.can_delete_attendees}
                                        onChange={(e) => onInputChange({
                                            target: {
                                                name: 'can_delete_attendees',
                                                value: e.target.checked
                                            }
                                        })}
                                    />
                                }
                                label="Can Delete Attendees"
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formData.can_edit_attendees}
                                        onChange={(e) => onInputChange({
                                            target: {
                                                name: 'can_edit_attendees',
                                                value: e.target.checked
                                            }
                                        })}
                                    />
                                }
                                label="Can Edit Attendees"
                            />
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formData.needs_organization}
                                        onChange={(e) => onInputChange({
                                            target: {
                                                name: 'needs_organization',
                                                value: e.target.checked
                                            }
                                        })}
                                    />
                                }
                                label="Needs Organization"
                            />
                        </div>
                    </div>
                    <div className="flex justify-end gap-4 mt-6 p-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blueColor text-white rounded"
                        >
                            {editData ? 'Save Changes' : 'Add'}
                        </button>
                    </div>
                </DialogContent>
            </form>
        </Dialog>
    );
};

export default EventTypeForm; 